import C from './constants'

export const setNews = (values) => (
    {
        type: C.SET_NEWS,
        payload: values 
    }
)
